export default __webpack_public_path__ + "static/media/Footpad's Mask of the Burning Temple.e60aeda6.jpg";